<div fxLayout="row wrap" class=container>

  <div fxFlex=100 class=toolbar-container>
    <gp-toolbar *ngIf="!isLogin()"></gp-toolbar>
  </div>

  <div fxFlex=100 class=outlet-container>
    <router-outlet></router-outlet>
  </div>

</div>
